'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';

/**
 * SelectOption component, used to display a native option within a select.
 *
 * @example
 * <Select>
 *   <Select.Option value='1'>Option 1</Select.Option>
 *   <Select.Option value='2'>Option 2</Select.Option>
 * </Select>
 */
const SelectOption = forwardRef(function SelectOption({ asChild, ...rest }, ref) {
    const Component = asChild ? Slot : 'option';
    return jsx(Component, { ...rest, ref: ref });
});

export { SelectOption };
